import { Box, Grid, Skeleton, Stack } from "@mui/material";
import { useContext } from "react";
import useResponsive from "src/hooks/useResponsive";

import Context from "../../../context";

// ----------------------------------------------------------------------

export const InfoStepSkeleton = () => {
	const { isFrame } = useContext(Context);

	const isMobile = useResponsive("down", "sm");
	const isDownMd = useResponsive("down", "md");
	return (
		<Stack width={isDownMd ? "auto" : 800} height={isMobile ? "auto" : isFrame ? 380 : 500}>
			<Skeleton variant='circular' width={50} height={50} sx={{ mb: 4.5, mt: 4 }} />
			<Grid container spacing={6}>
				<Grid item xs={12} sm={6}>
					<Stack>
						<Skeleton variant='text' width={190} />
						<Skeleton variant='text' sx={{ mb: 1 }} width={100} height={30} />
						<Skeleton variant='text' width={340} height={16} />
						<Skeleton variant='text' width={300} height={16} />
						<Skeleton variant='text' width={220} height={16} />
					</Stack>
					{!isMobile && <Skeleton variant='rectangular' sx={{ mt: 17 }} width={170} height={50} />}
				</Grid>
				<Grid item xs={12} sm={6}>
					<Stack gap={{ xs: 2, sm: 6 }}>
						<Stack flexDirection={"row"} alignContent={"start"}>
							<Skeleton variant='circular' width={20} height={20} />
							<Stack sx={{ ml: 2 }} gap={0.3}>
								<Skeleton variant='text' width={150} />
								<Skeleton variant='text' width={340} height={16} />
								<Skeleton variant='text' width={300} height={16} />
								<Skeleton variant='text' width={220} height={16} />
							</Stack>
						</Stack>
						<Stack flexDirection={"row"} alignContent={"start"}>
							<Skeleton variant='circular' width={48} height={20} />
							<Stack sx={{ ml: 2 }} gap={0.3}>
								<Skeleton variant='text' width={150} />
								<Skeleton variant='text' width={200} height={16} />
								<Skeleton variant='text' width={330} height={16} />
							</Stack>
						</Stack>
						<Stack flexDirection={"row"} alignContent={"start"}>
							<Skeleton variant='circular' width={20} height={20} />
							<Stack sx={{ ml: 2 }} gap={0.3}>
								<Skeleton variant='text' width={150} />
								<Skeleton variant='text' width={330} height={16} />
								<Skeleton variant='text' width={220} height={16} />
							</Stack>
						</Stack>
					</Stack>
				</Grid>
			</Grid>
			{isMobile && (
				<Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
					<Skeleton variant='rectangular' />
				</Box>
			)}
		</Stack>
	);
};

export default InfoStepSkeleton;
